import React from 'react';
import ReactDOM from 'react-dom';

export const Glass = ({ glass }) => {
  return glass ? ReactDOM.createPortal(
    <React.Fragment>
      <div className="modal-overlay glass"></div>
    </React.Fragment>, document.body
  ) : null;
} 